import type { EventLevel } from '@/types'

interface Props {
  level: string
}

const LEVEL_STYLE: Record<string, { bg: string; text: string; label: string }> = {
  error:   { bg: '#fdecea', text: '#c62828', label: 'ERROR' },
  warning: { bg: '#fff8e1', text: '#f57f17', label: 'WARN' },
  info:    { bg: '#e3f2fd', text: '#1565c0', label: 'INFO' },
}

export default function EventBadge({ level }: Props) {
  const s = LEVEL_STYLE[level as EventLevel] ?? { bg: '#f0f0f0', text: '#555', label: level.toUpperCase() }
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '1px 8px',
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.04em',
        background: s.bg,
        color: s.text,
        whiteSpace: 'nowrap',
        fontFamily: 'monospace',
      }}
    >
      {s.label}
    </span>
  )
}
